<template>
  <div>
    <div v-if="!enterDetail">
      <div v-show="!enterCreate">
        <div class="header">
          <div class="header-left">
            <img :src='currentConsultImgSrc' />
            <button class="header-title" >刘老师</button>
          </div>
          <div class="header-middle">
            <p>仁能达生涯研究院副院长</p>
            <p>北师大心理学硕士</p>
            <p>高级咨询师</p>
            <p>累计咨询时长超过1000小时</p>
          </div>
          <!-- <div class="header-right">
            <button class="onlineStatus" >在线中</button>
          </div> -->
        </div>
        <div class="middle">
          <button :class="invalid?'play-button':'disabled-btn'" @click="handleStartConsult" :invalid="checkStatus">咨询</button>
          <div class="middle-title">我的咨询</div>
          <div class="middle-area">
            <ConsultBox v-for="(item, index) in myConsults" :consult="item" :isMy="true" :index="index" @enterDetail="handleEnterDetail"></ConsultBox>
          </div>
        </div>
        <div class="bottom">
           <button class="back-button" @click="emitBackActivities" >返回活动广场</button>
        </div>
      </div>
      <div v-show="enterCreate">
        <ConsultCreate @back-consult="handleBackConsult" @created-consult="handleCreatedConsult"/>
      </div>
    </div>
    <div v-else>
      <ConsultDetail :consult="currentConsult" :isMy="currentIsMy" @back-consult="handleBackConsult"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
import ConsultBox from '@/components/consult/consultBox.vue'
import ConsultDetail from '@/page/consultDetail.vue'
import ConsultCreate from '@/page/consultCreate.vue'
import moment from 'moment'
export default {
  name: 'Consult',
  props: {
  },
  components: {
    ConsultBox,
    ConsultCreate,
    ConsultDetail,
  },

  data () {
    console.log('开始 consult data() id：')
    return {
      id: 99, //咨询室特定号码
      enterCreate: false,
      enterDetail: false,
      currentConsult: {},
      currentIsMy: false,
      myConsults: [],
      allConsults: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 5,
      invalid:true
		}
  },

  computed: {
    ...mapState({
      currentGroupMemberNum: state => state.conversation.currentGroupMemberNum,
			shengyaUser: state => state.shengyaUser.userInfo,
    }),
		partnerCode() {
			return this.shengyaUser.admin.manageAccCode.replace('admin','')
		},
    groupID() {
      return this.partnerCode+'-cos-mission-99'
    },
		currentConsultImgSrc() {
			return 'http://sys.rennengda.com/public/images/consult/consult-1.jpg'
		},
    isCompleted() {
      return this.totalCount<= this.currentPage * this.pageSize
    },
    checkStatus(){
      let invalid=true
      let b = this.shengyaUser.admin.endDate
      let day = moment().diff(moment().format(), 'days')
      if(day<0){
        invalid= false
      }
      this.invalid = invalid
      return invalid
    }
  },
  created(){
    setWechatTitle('生涯驿站-咨询');
  },
  mounted() {
    console.log('开始 consult mounted groupID：'+ this.groupID)
    this.getMyConsult()
    this.$bus.$on('judge-consult', this.handleJudgeConsult)
  },
  updated() {
  },
  beforeDestroy () {
    // console.log('开始 mission beforeDestroy() 关闭监听')
  },
  methods: {
    getMyConsult() {
      const options = {
        method: 'post',
        headers: {'content-type': 'application/x-www-form-urlencoded'},
        data: qs.stringify({
          openId: this.shengyaUser.openid
        }),
        url:'/cob/cosMyConsult.do'
      };
      axios(options)
      .then( (res) => {
        const data = res.data.data;
        if(data){
          this.myConsults = data;
        }
      })
      .catch(function (error) {
        console.warn(error);
      })
    },
    //咨询
    handleStartConsult() {
      if(this.invalid){
        this.enterCreate = true
      }else{
        this.$store.commit('showMessage', {
          message: '已过有效期，暂不能使用该功能',
          type: 'warning',
          duration:4000
        })
      }
    },
    handleBackConsult() {
      this.enterCreate = false
      this.enterDetail = false
    },
    handleCreatedConsult(consult) {
      this.myConsults.push(consult)
      this.enterCreate = false
    },
    handleEnterDetail(index ,isMy) {
      console.warn('handleEnterDetail\'s index：'+index)
      this.currentConsult = this.myConsults[index]
      this.currentIsMy = isMy
      this.enterDetail = true
    },
    handleJudgeConsult(judgedConsult) {
      this.myConsults.map(consult => {
        if(consult.id === judgedConsult.id) {
          console.warn('handleJudgeConsult\'s consult.id：'+consult.id)
          consult.starNum = judgedConsult.starNum
          consult.status = judgedConsult.status
        }
      })
    },
    //返回活动广场
    emitBackActivities() {
      // this.$store.dispatch('quitMissionGroup',this.id)
        this.$bus.$emit('back-activities')
    },
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.onlineInfo
  text-align: right
  margin: 0.14rem 0.58rem 0.14rem 1rem
  color: #777
  font-size: 0.24rem;
  .number
    color: #FB8D3E
    font-size: 0.28rem;
.header
  display: flex
  overflow: hidden
  margin: 0 0.24rem
  padding: 0.12rem 0.24rem
  background: #fff;
/* height: 1.0rem  */
  .header-left
    width: 1rem
    float: left
    img
      width: 0.84rem
      height: 0.84rem
      padding: 0 0.1rem
    .header-title
      background: #1798D3;
      padding: 0 0.1rem;
      border-radius: 0.08rem;
      color: #fff;
      font-size: 0.24rem;
  .header-middle
    flex: 1
    line-height: 0.28rem
    padding: 0.05rem 0.2rem
    color: #101010
    font-size: 0.24rem;
  .header-right
    min-width: 1.1rem
    padding: 0 .1rem
    float: right
    .onlineStatus
      float: right
      background: #1798D3;
      margin-top: 0.32rem
      padding: 0.1rem 0.1rem;
      color: #fff;
      font-size: 0.28rem;

.middle
  padding: 0.24rem
  max-height: 70vh;
  overflow-x: auto;
  .play-button
    width: 100%
    height: 0.84rem
    background: #FB8D3E
    border-radius: 0.12rem
    color: #fff
  .disabled-btn
    width: 100%
    height: 0.84rem
    border-radius: 0.12rem
    color: #fff
  .middle-title
    margin: 0.28rem 0 0.1rem 0
    text-align :center
    color :#101010
  .middle-area
    background-color :#FFFFFF
    padding: 0.02rem 0.12rem
  .more
    display: flex;
    justify-content: center;
    .el-button
      padding: 0 20px
      font-size 12px
      color:#008DCF
  .no-more
    display: flex;
    justify-content: center;
    color: $secondary;
    font-size: 12px;
    padding: 0px 10px;

.bottom
  padding: 0.24rem
  .back-button
    width: 100%
    height: 0.84rem
    background: #787878
    border-radius: 0.12rem
    color: #fff
  .disabled-btn
    background :#BBBBBB
</style>
